<template>
  <div class="color-dot" :class="[{ 'color-dot--no-color': !color }]">
    <div class="color-dot__background" :style="{ background: color }" data-test-id="color-dot-background"></div>
    <div class="color-dot__dot" :style="{ background: color }" data-test-id="color-dot-dot"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ColorDot',

  props: {
    color: {
      required: true,
      type: String,
    },
  },
});
</script>

<style lang="scss">
@use 'settings/colors';
@use 'settings/settings';
.color-dot {
  display: grid;
  align-items: center;
  justify-items: center;
}

.color-dot__background,
.color-dot__dot {
  grid-column: 1;
  grid-row: 1;
}

.color-dot__background {
  height: 24px;
  width: 24px;
  border-radius: settings.$border-radius;
  opacity: 0.2;
}

.color-dot__dot {
  height: 12px;
  width: 12px;
  border-radius: 50%;
}

// stolen from color circle
.color-dot--no-color .color-dot__background {
  --checkerSize: 6px;
  --checkerColor: #ffffff;
  --checkerAltColor: #e5e5e5;

  background-image: linear-gradient(45deg, var(--checkerColor) 25%, transparent 25%),
    linear-gradient(135deg, var(--checkerColor) 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, var(--checkerColor) 75%),
    linear-gradient(135deg, transparent 75%, var(--checkerColor) 75%);
  background-color: var(--checkerAltColor);

  background-size: calc(2 * var(--checkerSize)) calc(2 * var(--checkerSize));

  background-position: 0 0, var(--checkerSize) 0, var(--checkerSize) calc(-1 * var(--checkerSize)),
    0px var(--checkerSize);

  box-shadow: settings.$box-shadow-border-grey-80;
}
</style>
